
import {
getOrderList,
orderCancel
} from '../api/order-status-cart.js'
import Api from '../api.js'
import Vue from 'vue'
import {
isAlipayOrWechat
} from '../utils/common.js'
import Alert from 'vux/src/components/alert/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
data() {
return {
orderList: [], //订单列表
imagesUrl: Api.imgUrl,
status: 0, //付款状态  0全部，1:待付款,3:已付款,7:已取消  默认全部
lastId: 0, //当前页最后一订单ID(首次传0或空)
showNoList: false, //是否没有数据
isLoad: true, //是否触底加载
showBottom: false, //是否显示底线
shwoLoading:false,//显示加载中
};
},
directives: {
TransferDom
},
components: {
Loading
},

created() {

},
mounted: function() {
this.getOrderListFun(); 

window.addEventListener("scroll", this.onScroll);
},
destroyed() {

window.removeEventListener("scroll", (this.onScroll));
},
methods: {

getOrderListFun: function() {
let that = this;
that.shwoLoading = true;
let str = '?status=' + that.status + '&lastId=' + that.lastId + '&size=5'
getOrderList(str).then(res => {
console.log("返回--------", res)
if (res.code == 1) {
that.isLoad = true;
let oldList = that.orderList;
let newList = oldList.concat(res.data);
that.orderList = newList;
console.log("that.orderList--------", that.orderList)

if (res.data.length <= 0) {
that.showBottom = true;
}
if (that.orderList.length > 0) {
that.lastId = that.orderList[that.orderList.length - 1].id
} else {
that.showNoList = true;
}

}

that.shwoLoading = false;
})
},


changeStatesFun: function(status) {
this.status = status;
this.orderList = [];
this.lastId = 0;
this.showBottom = false;
this.showNoList = false;
this.isLoad = false;
this.getOrderListFun(); 
},


orderCancelFun: function(code) {
orderCancel(code).then(res => {
console.log("返回--------", res)
if (res.code == 1) {
this.orderList = [];
this.lastId = 0;
this.getOrderListFun(); 
}
})
},


orderPayFun: function(code) {
let method = isAlipayOrWechat();
if (method == "wx") {
location.href = Api.wechatcart + '?code=' + code;
} else {

location.href = Api.alicart + '?code=' + code;
}
},


orderInfoFun: function(code) {
this.$router.push({
path: '/CartOrderdetail',
query: {
code: code
}
})
},
onScroll: function() {

let innerHeight = this.$el.clientHeight;

let outerHeight = document.documentElement.clientHeight;

let scrollTop = document.documentElement.scrollTop;

if (scrollTop == 0) {
innerHeight = 10000
}

if (this.isLoad) {
if (innerHeight <= outerHeight + scrollTop) {
console.log("到底部---")
this.isLoad = false;

this.getOrderListFun(); 
}
}
},

gotoMyOrder:function(){
location.href = "https://trade.reflower.com.cn/order/myorder"
}
},

filters: {

dateFormat: function(dataStr) {
var time = new Date(dataStr);

function timeAdd0(str) {
if (str < 10) {
str = '0' + str;
}
return str
}
var y = time.getFullYear();
var m = time.getMonth() + 1;
var d = time.getDate();
var h = time.getHours();
var mm = time.getMinutes();
var s = time.getSeconds();
return y + '-' + timeAdd0(m) + '-' + timeAdd0(d);
}
}
}



// WEBPACK FOOTER //
// ./src/view/order-status-cart.vue